import { render, staticRenderFns } from "./PavilionButton.vue?vue&type=template&id=c0c6d506&scoped=true&"
import script from "./PavilionButton.vue?vue&type=script&lang=ts&"
export * from "./PavilionButton.vue?vue&type=script&lang=ts&"
import style0 from "./PavilionButton.vue?vue&type=style&index=0&id=c0c6d506&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0c6d506",
  null
  
)

export default component.exports